import { api_url } from "../../../utils";

const TerminalTerrestre = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=terminal_terrestre&schema_city=",
    zindex: 3,
    type: "single",
    popup: {
        default: {
            content: {
                es: {
                    name: "Nombre del terminal terrestre:",
                },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.TerminalTerrestre",
    style: {
        regular: true,
        fillColor: "rgba(72, 123, 182, 1)",
        strokeColor: "rgba(53, 92, 135, 1)",
        strokeWidth: 2,
        strokeLineDash: [],
        points: 4,
        radius: 6,
        angle: 25,
        rotation: 30,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.TerminalTerrestre.title",
            subtitle: "",
            attribute: "",
            symbol: "diamond",
            legendCustomCssClass:
                "map-legend-symbol-8px map-legend-symbol-border-2px-blue-53-92-135",
            class: [
                {
                    fillColor: "rgba(72, 123, 182, 1)",
                    strokeColor: "rgba(72, 123, 182, 1)",
                    strokeWidth: 0,
                    label: "Mobility Indicators Content.layersLegend.TerminalTerrestre.classes.1",
                },
            ],
        },
    },
};

export default TerminalTerrestre;
